export default {"src":"/_next/static/media/regularText.ec815215.svg","height":366,"width":592};